import { render, staticRenderFns } from "./tongbu.vue?vue&type=template&id=de0debf2"
import script from "./tongbu.vue?vue&type=script&lang=js"
export * from "./tongbu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports